<script setup lang="ts">
import UiSticker, { type UiStickerProps } from '@/modules/ui/components/ui/UiSticker.vue';

export interface StickerCellProps extends UiStickerProps {
  text: string;
}

defineProps<StickerCellProps>();
</script>

<template>
  <UiSticker v-bind="$props">
    {{ $t(text) }}
  </UiSticker>
</template>
